import { get } from 'lodash';
import { GET_FORM_ACTIONS_REQUEST } from './';
import { getActions } from '../api/reports';
import getFormActionsSuccess from './get-form-actions-success';
import getFormActionsError from './get-form-actions-error';
import byTypeAndIdFunctionCacher from '../components/form-viewer/field-types/typeIdFunctionCache';

export default (
  { agencyId, formSubmissionId = '', templateId },
  next = () => {}
) => async dispatch => {
  dispatch({ type: GET_FORM_ACTIONS_REQUEST });

  return new Promise(async resolve => {
    try {
      const actions = await byTypeAndIdFunctionCacher.getIfCached(
        'actions',
        formSubmissionId,
        () =>
          getActions({
            agencyId,
            formSubmissionId,
            templateId,
          })
      );
      dispatch(getFormActionsSuccess(actions));
      next(false, actions);
      resolve(actions);
    } catch (e) {
      dispatch(getFormActionsError(get(e, ['response', 'status'])));
      next(e);
    }
  });
};
